var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "upload-cover-scribe-component",
        { complete: _vm.status === "COMPLETE" || _vm.image.initImageUrl }
      ]
    },
    [
      _c("input", {
        attrs: { type: "hidden", name: "card[cover_image]" },
        domProps: { value: _vm.image.id }
      }),
      _vm._v(" "),
      _c(
        "div",
        { ref: "wrapper", staticClass: "content-wrapper" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.status === "COMPLETE" || _vm.image.initImageUrl,
                  expression: "status === 'COMPLETE' || image.initImageUrl"
                }
              ],
              staticClass: "displaying-image"
            },
            [
              _vm.image.croppedImageUrl
                ? _c("img", {
                    staticClass: "cropped-image",
                    attrs: {
                      src: _vm.image.croppedImageUrl,
                      alt: "Cropped Image"
                    }
                  })
                : _vm.image.initImageUrl
                ? _c("img", {
                    staticClass: "cropped-image",
                    attrs: { src: _vm.image.initImageUrl, alt: "Init Image" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "control-panel" }, [
                _c(
                  "div",
                  {
                    staticClass: "btn btn-danger btn-del",
                    on: {
                      click: function($event) {
                        return _vm.closeCropperModal()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-trash" })]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.showCropper &&
                    _vm.status !== "COMPLETE" &&
                    !_vm.image.initImageUrl,
                  expression:
                    "!showCropper && status !== 'COMPLETE' && !image.initImageUrl"
                }
              ],
              class: [
                "upload-dropzone",
                {
                  "in-progress": !["INITIATED", "COMPLETE"].includes(
                    _vm.status
                  ),
                  dragover: _vm.dragover
                }
              ],
              on: {
                click: _vm.onClick,
                drop: function($event) {
                  $event.preventDefault()
                  return _vm.onDrop.apply(null, arguments)
                },
                dragover: function($event) {
                  $event.preventDefault()
                  _vm.dragover = true
                },
                dragleave: function($event) {
                  $event.preventDefault()
                  _vm.dragover = false
                }
              }
            },
            [
              _c("input", {
                ref: "fileInput",
                attrs: { type: "file", accept: ".jpeg, .jpg, .png" },
                on: {
                  change: function($event) {
                    return _vm.selectionProcessing($event)
                  }
                }
              }),
              _vm._v(" "),
              _vm.status === "INITIATED"
                ? _c("div", [
                    _c("div", { staticClass: "upload-image-title" }, [
                      _c("div", { staticClass: "bold-text" }, [
                        _vm._v("Drag your image here or click to add one")
                      ]),
                      _vm._v(" "),
                      _c("small", {}, [
                        _vm._v(
                          "The max file size: " +
                            _vm._s(_vm.maxSize / 1024 / 1024) +
                            " MB"
                        )
                      ])
                    ])
                  ])
                : _vm.status === "CHECKING"
                ? _c("div", [_vm._v("Checking...")])
                : _vm.status === "UPLOADING"
                ? _c("div", [_vm._v(_vm._s(_vm.image.upload_percentage) + "%")])
                : ["COMPLETE"].includes(_vm.status)
                ? _c("div", [_vm._v("Complete")])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm.showCropper
            ? _c("vue-cropper", {
                ref: "cropper",
                staticClass: "vue-cropper",
                attrs: {
                  src: _vm.image.url,
                  alt: "Source Image",
                  viewMode: 3,
                  autoCropArea: 1,
                  cropBoxResizable: false,
                  cropBoxMovable: false,
                  guides: false,
                  aspectRatio: 3 / 2,
                  dragMode: "move",
                  minCropBoxWidth: _vm.minCropBoxWidth
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showCropper && ["CHECKING", "INITIATED"].includes(_vm.status)
            ? _c("div", { staticClass: "control-panel" }, [
                _c(
                  "div",
                  {
                    staticClass: "btn btn-default",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.cropper.relativeZoom(0.1)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-search-plus" })]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn btn-default",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.cropper.zoomTo(1)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-arrows-alt" })]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn btn-default",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.cropper.relativeZoom(-0.1)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-search-minus" })]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn btn-default",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.cropper.rotate(-45)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-undo-alt" })]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn btn-default",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.cropper.rotate(45)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-redo-alt" })]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn btn-danger",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.closeCropperModal()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-times" })]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn btn-success upload",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.done()
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-check" })]
                )
              ])
            : _vm.showCropper && ["UPLOADING", "UPLOADED"].includes(_vm.status)
            ? _c("div", { staticClass: "control-panel upload-status" }, [
                _c("div", { staticClass: "btn btn-default uploading" }, [
                  _vm.status === "UPLOADING"
                    ? _c("div", [
                        _vm._v(_vm._s(_vm.image.upload_percentage) + "%")
                      ])
                    : _c("div", [_vm._v("Saving...")])
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }